import React, { createContext, useContext, useEffect, useState } from "react";
import { get, post, apiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=user

  const refresh = async () => {
    try {
      const me = await get("/auth/me");
      setUser(me);
      return me;
    } catch {
      setUser(false);
      return false;
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  const login = async (payload) => {
    const u = await post("/auth/login", payload);
    setUser(u);
    return u;
  };
  const register = async (payload) => {
    const u = await post("/auth/register", payload);
    setUser(u);
    return u;
  };
  const otpVerify = async (payload) => {
    const u = await post("/auth/otp/verify", payload);
    setUser(u);
    return u;
  };
  const logout = async () => {
    try { await post("/auth/logout", {}); } catch {}
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, otpVerify, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export { apiError };
